// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { makeReferenceResolver } from 'reference-resolvers/ReferenceResolver';
import emptyFunction from 'react-utils/emptyFunction';
import valueSeq from 'transmute/valueSeq';
export default makeReferenceResolver({
  all(next) {
    next(valueSeq([]));
    return emptyFunction;
  },
  byId(id, next) {
    next();
    return emptyFunction;
  }
});